module.exports = __webpack_public_path__ + "img/Title5.d3464127.png";